/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  // Options.jsx
  items_per_page: '/ ÑÑÑÐ´Ð°Ñ',
  jump_to: 'Ð¨Ð¸Ð»Ð¶Ð¸Ñ',
  jump_to_confirm: 'ÑÐ¾Ð½Ð³Ð¾Ñ',
  page: '',

  // Pagination.jsx
  prev_page: 'Ó¨Ð¼Ð½Ó©Ñ ÑÑÑÐ´Ð°Ñ',
  next_page: 'ÐÐ°ÑÐ°Ð°Ð³Ð¸Ð¹Ð½ ÑÑÑÐ´Ð°Ñ',
  prev_5: 'ÐÐ°ÑÐ°Ð°Ð³Ð¸Ð¹Ð½ 5 ÑÑÑÐ´Ð°Ñ',
  next_5: 'ÐÐ°ÑÐ°Ð°Ð³Ð¸Ð¹Ð½ 5 ÑÑÑÐ´Ð°Ñ',
  prev_3: 'ÐÐ°ÑÐ°Ð°Ð³Ð¸Ð¹Ð½ 3 ÑÑÑÐ´Ð°Ñ',
  next_3: 'ÐÐ°ÑÐ°Ð°Ð³Ð¸Ð¹Ð½ 3 ÑÑÑÐ´Ð°Ñ'
};
